import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Card, CardHeader, CardContent, Typography, Icon} from '@material-ui/core'
import {compose} from 'redux'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import { withCotation, CtxCotation } from 'src/page/Consumer/Cotation/CotationProvider'
import * as moment from 'moment'
import autobind from 'autobind-decorator'
import PcDialog from 'src/shared/Dialog/PcDialog'
import Btn from 'src/shared/Btn/Btn'

import SummaryContext from 'src/shared/Cotation/summary/SummaryContext'

const styles = (t: Theme) => createStyles({
    card: {
        height: '100%',
        marginBottom: t.spacing.unit * 2
    },
    cardTitle: {fontSize: '1.2rem',textTransform: 'uppercase'},
    historyWpr: {
      maxHeight: '450px',
      overflow: 'auto'
    },
    historyItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: `${t.spacing.unit}px`,
      marginBottom: t.spacing.unit,
      borderBottom: '1px solid rgba(224, 224, 224, 1)'
    },
    info: {
      display: 'flex',
      flexDirection: 'column'
    }
});


interface IProps extends WithI18n,
  WithStyles<typeof styles>,
  CtxCotation {
}

interface IState{
  isModalOpen: boolean;
  paramIdSelected: string | undefined;
}

class History extends React.Component<IProps, IState> {
  state = {
    isModalOpen: false,
    paramIdSelected: undefined
  }

  render() {
    const {t, classes, paramsHistory} = this.props;

    return (
        <Card className={classes.card}>
            <CardHeader classes={{title: classes.cardTitle}}  title={
              <div style={{display: 'flex', alignItems: 'center'}}>
                <Icon style={{marginRight: '5px'}}>assignment</Icon>
                {t.Cotation_last_version}
              </div>
            } />
            <CardContent style={{overflow: 'visible'}}>
              {paramsHistory &&
                <>
                  <div className={classes.historyWpr}>
                    {paramsHistory.data.map((h, i) => (
                      <div className={classes.historyItem} key={`version-wpr-${i}`}>
                        <div className={classes.info}>
                          <Typography variant="body2" gutterBottom>{h.cotation.last_updated_by}</Typography>
                          <Typography variant="caption">
                            <span>{t.Cotation_has_been_modifed} </span>
                            {moment(new Date(h.cotation.last_updated_at)).format("DD/MM/YYYY HH:mm:ss")}
                          </Typography>
                        </div>
                        <Btn
                            color="primary"
                            variant="raised"
                            onClick={() => this.toggleModal(true, h.id)}
                        >
                          {t.settings}
                        </Btn>
                      </div>  
                    ))}
                  </div>
                  
                  <PcDialog
                    open={this.state.isModalOpen}
                    maxWidth="md"
                    title={t.Cotation_setting_params}
                    fullWidth={true}
                    actions={
                      <Btn
                          color="primary"
                          variant="raised"
                          onClick={() => this.toggleModal(false, undefined)}
                      >
                          {t.close}
                      </Btn>
                    }
                  >
                    {this.state.isModalOpen && this.summaryRender()}
                  </PcDialog>
                </>
              }
            </CardContent>
        </Card>
    )
  }

  @autobind
  private toggleModal(isOpen, id){
    this.setState({isModalOpen: isOpen, paramIdSelected: id})
  }

  @autobind
  private summaryRender(){
    const {productType, paramsHistory} = this.props;
    const {paramIdSelected} = this.state
    const data = paramsHistory.data.find(p => p.id === paramIdSelected)
    return (
      <SummaryContext
        formParams={data}
        productType={productType}
        firstLabel="PARAMÈTRES DE LA COTATION"
        secondLabel="PARAMÈTRES RÉSERVÉS À LA SALLE DES MARCHÉS"
        showSaleValue={true}
      />
    )
  }

}

export default compose(
  withCotation,
  withI18n,
  withStyles(styles)
)(History)



// WEBPACK FOOTER //
// ./src/page/Consumer/Cotation/History.tsx